import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jh_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Fetch restaurants for a city. If that city has none seeded yet (common while
// the catalog is still small), fall back to ALL available restaurants so the
// user is never stuck on an empty "0 restaurants" screen. Network errors (e.g.
// transient 520) propagate so callers can retry.
// Only restaurants serving the given city — never fall back to other cities.
export async function fetchRestaurants(cityId) {
  const { data } = await api.get("/restaurants", { params: { city: cityId } });
  return Array.isArray(data) ? data : [];
}
